import * as React from "react";
import LoginFormBtmTxt from "../generic/loginFormBtmTxt";
import EdButton from "../../generic/edButton";
import YobInputField from "../generic/yobInputField";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import "../../../assets/scss/Login/login/loginScreen/yobScreen.scss";
import LoginErrMsg from "../generic/loginErrMsg";
import appUrl from "../../../config/MyApp/myAppsURLConfig";
import DefaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface IYobScreenProps {
  disableForm: boolean;
  errorMsg?: string;
  securityImgObj: any;
  onSubmit: (yob: string) => void;
  onClose?: () => void;
  onRemoveError: () => void; // removes the errorMsg
}

const YobWithAPi: React.FC<IYobScreenProps> = (props) => {
  const [yob, setYob] = React.useState("");

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    props.onSubmit(yob);
  }

  React.useEffect(() => {
    if (props.errorMsg) {
      props.onRemoveError();
    }
  }, [yob]);

  return (
    <div className="loginWithApi">
      <div className="loginWithApi_container">
        <div className="loginWithApi_head">
          <span>
            <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
          </span>
          <span>
            <i className="edel-icon-close" onClick={props.onClose}></i>
          </span>
        </div>
        <div className="loginWithApi_contant">
          <div className="loginWithApi_appInfo">
            <img
              src={
                props.securityImgObj.logo
                  ? appUrl.appIcon + props.securityImgObj.logo
                  : DefaultAppIcon
              }
              alt="logo"
            />
            <h3>{props.securityImgObj.appNm}</h3>
          </div>
          <div className="login_form yob_form">
            <form onSubmit={handleSubmit} autoComplete="off" className="mg-b60">
              <label className="inp_lbl mg-b15 ib">Year of Birth</label>

              <YobInputField placeholder="Y" onChange={setYob} />
              <p className="help_text mg-b40">
                * For HUF/corporate, enter your year of incorporation/
                registration.
              </p>

              {props.errorMsg && (
                <LoginErrMsg className="mg-b40">{props.errorMsg}</LoginErrMsg>
              )}

              <EdButton
                value="Proceed"
                btnTyp="primary"
                className="submit_btn"
                disabled={props.disableForm || yob.length < 4}
              />
            </form>

            <LoginFormBtmTxt />
          </div>
        </div>
      </div>
    </div>
  );
};

export default YobWithAPi;
